import { Box, Container, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import type { ReactElement, ReactNode } from "react";

/** Shared frame for authentication and account recovery screens. */
export default function PublicPageFrame({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const { t } = useTranslation("common");
  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{ py: { xs: 3, sm: 6 }, px: { xs: 2, sm: 3 } }}
    >
      <Box sx={{ mb: 3 }}>
        <Link
          component={RouterLink}
          to="/auth"
          underline="none"
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            letterSpacing: "-0.035em",
          }}
        >
          {t("appName")}
        </Link>
      </Box>
      {children}
    </Container>
  );
}
